module.exports = __webpack_public_path__ + "static/media/weatherIcon.6ce3d3b5.png";